import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

export default function Dialog({ open, cancel, title, message, proceed, proceedText = 'Yes', cancelText = 'Cancel', innerTitle = 'Are you sure?'}) {
  return (
    <Modal isOpen={open} toggle={cancel}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <div className="text-danger">
            <span className="modal-main-icon s7-attention" />
          </div>
          <h3 className="mb-4">{innerTitle}</h3>
          <p>{message}</p>
        </div>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        {!!proceed && 
        <Button
          color="danger"
          onClick={proceed}
          className="btn-md-lateral-space mr-2"
        >
          {proceedText}
        </Button> }
        <Button
          color="secondary"
          onClick={cancel}
          className="btn-md-lateral-space mr-2"
        >
          {cancelText}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

Dialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  cancel: PropTypes.func,
  proceed: PropTypes.func,
  proceedText: PropTypes.string,
  cancelText: PropTypes.string,
  innerTitle: PropTypes.string
};

Dialog.defaultProps = {
  open: undefined,
  title: '',
  message: '',
  cancel: undefined,
  proceed: undefined,
  proceedText: 'Yes',
  cancelText: 'Cancel',
  innerTitle: 'Are you sure?'
};



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js